import {
  Card,
  Group,
  NumberInput,
  Stack,
  Text,
  TextInput,
} from '@mantine/core';
import { useClientFormContext } from '../ClientPersonalSection';
import { type ClientDetailed } from '@/schemas/API/GET/client/response';

export type ClientAddressType = 'Servisní adresa' | 'Trvalá adresa';

export const AddressCard = ({
  addressType,
}: {
  addressType: ClientAddressType;
}): JSX.Element => {
  const form = useClientFormContext();

  const addr: keyof ClientDetailed =
    addressType === 'Servisní adresa' ? 'servAddress' : 'permAddress';

  return (
    <Card padding="md" radius="md" withBorder>
      <Text fw={700} size="large">
        {addressType}
      </Text>

      <Stack gap="sm" className="mt-3">
        <TextInput
          variant="filled"
          radius="md"
          placeholder="note"
          label="Ulice"
          {...form.getInputProps(`${addr}.street`)}
        />

        <Group justify="space-between" grow align="start">
          <NumberInput
            variant="filled"
            radius="md"
            placeholder="note"
            label="Č.p"
            value={form.values[addr].descNum}
            onChange={(n: any) => {
              form.setFieldValue(`${addr}.descNum`, Number(n));
            }}
            min={0}
            error={form.getInputProps(`${addr}.descNum`).error}
            allowDecimal={false}
          />
          <NumberInput
            variant="filled"
            radius="md"
            placeholder="note"
            label="Č.o"
            value={form.values[addr].orientNum}
            onChange={(n: any) => {
              form.setFieldValue(`${addr}.orientNum`, Number(n));
            }}
            min={0}
            error={form.getInputProps(`${addr}.orientNum`).error}
            allowDecimal={false}
          />
        </Group>

        <TextInput
          variant="filled"
          radius="md"
          placeholder="note"
          label="Město"
          {...form.getInputProps(`${addr}.city`)}
        />
        <TextInput
          variant="filled"
          radius="md"
          placeholder="note"
          label="PSČ"
          {...form.getInputProps(`${addr}.postCode`)}
        />
      </Stack>
    </Card>
  );
};
